import React from 'react';
import './Cards.css';
import { Link } from 'react-router-dom';
// import CardItem from './CardItem';

function Cards() {
    return (
        <div className='cards'>
            <div class="container">
                {/* <!-- Card --> */}
                <div>
                    <div class="card">
                        <div class="img">
                            <img src="images/chinelo.jpg" alt='' />
                        </div>
                        <div class="content">
                        </div>
                        <div>
                            <h3 className='nome'>Sandália Amora</h3>
                            <div class="price"><span>R$  </span>40,00</div>
                            <div class="icon">
                            <Link class="icon"
                to='/carrinho'
              ><a href="carrinho" class="fas fa-shopping-cart"><span></span></a>
    </Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="card">
                        <div class="img">
                            <img src="images/comamor.jpg" alt='' />
                        </div>
                        <div class="content">
                        </div>
                        <div>
                            <h3 className='nome'>Bolsa com amor</h3>
                            <div class="price"><span>R$  </span>40,00</div>
                            <div class="icon">
                                <a href="bolsa" class="fas fa-shopping-cart"><span></span></a>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card">
                    <div class="img">
                        <img src="images/cestinhos.jpeg" alt='' />
                    </div>
                    <div class="content">
                    </div>
                    <div>
                        <h3 className='nome'>Cestinhos azuis</h3>
                        <div class="price"><span>R$  </span>40,00</div>
                        <div class="icon">
                            <a href="cesto" class="fas fa-shopping-cart"><span></span></a>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="img">
                        <img src="images/4.jpg" alt='' />
                    </div>
                    <div class="content">
                    </div>
                    <div>
                        <h3 className='nome'>Vazo com suporte</h3>
                        <div class="price"><span>R$  </span>40,00</div>
                        <div class="icon">
                            <a href="vazo" class="fas fa-shopping-cart"><span></span></a>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="img">
                        <img src="images/6.jpg" alt='' />
                    </div>
                    <div class="content">
                    </div>
                    <div>
                        <h3 className='nome'>Porta objeto</h3>
                        <div class="price"><span>R$  </span>40,00</div>
                        <div class="icon">
                            <a href="porta" class="fas fa-shopping-cart"><span></span></a>
                        </div>
                    </div>
                </div>
                {/* <!-- Card --> */}
                <div class="card">
                    <div class="img">
                        <img src="images/7.jpg" alt='' />
                    </div>
                    <div class="content">
                    </div>
                    <div>
                        <h3 className='nome'>Cesto branco</h3>
                        <div class="price"><span>R$  </span>40,00</div>
                        <div class="icon">
                            <a href="cesto" class="fas fa-shopping-cart"><span></span></a>
                        </div>
                    </div>
                </div>
                <div class="container">
                    {/* <!-- Primeiro Card --> */}
                    <div class="card">
                        <div class="img">
                            <img src="images/1.png" alt='' />
                        </div>
                        <div class="content">
                        </div>
                        <div>
                            <h3 className='nome'>Bolsa Yellow</h3>
                            <div class="price"><span>R$  </span>40,00</div>
                            <div class="icon">
                                <a href="yellow" class="fas fa-shopping-cart"><span></span></a>
                            </div>
                        </div>
                    </div>
                    {/* <!-- Card --> */}
                    <div class="card">
                        <div class="img">
                            <img src="images/3.png" alt='' />
                        </div>
                        <div class="content">
                        </div>
                        <div>
                            <h3 className='nome'>Chaveiros heart verde</h3>
                            <div class="price"><span>R$  </span>40,00</div>
                            <div class="icon">
                                <a href="chaveiro" class="fas fa-shopping-cart"><span></span></a>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="img">
                            <img src="images/4.png" alt='' />
                        </div>
                        <div class="content">
                        </div>
                        <div>
                            <h3 className='nome'>Chaveiros heart Red</h3>
                            <div class="price"><span>R$  </span>40,00</div>
                            <div class="icon">
                                <a href="chaveiro" class="fas fa-shopping-cart"><span></span></a>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="img">
                            <img src="images/5.png" alt='' />
                        </div>
                        <div class="content">
                        </div>
                        <div>
                            <h3 className='nome'>Kit para bebê</h3>
                            <div class="price"><span>R$  </span>40,00</div>
                            <div class="icon">
                                <a href="kit" class="fas fa-shopping-cart"><span></span></a>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="img">
                            <img src="images/6.png" alt='' />
                        </div>
                        <div class="content">
                        </div>
                        <div>
                            <h3 className='nome'>Bolsa Black</h3>
                            <div class="price"><span>R$  </span>40,00</div>
                            <div class="icon">
                                <a href="bolsa" class="fas fa-shopping-cart"><span></span></a>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="img">
                            <img src="images/2.png" alt='' />
                        </div>
                        <div class="content">
                        </div>
                        <div>
                            <h3 className='nome'>Bolsa Pink</h3>
                            <div class="price"><span>R$  </span>40,00</div>
                            <div class="icon">
                                <a href="bolsa" class="fas fa-shopping-cart"><span></span></a>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="container">
                    <div class="card">
                        <div class="img">
                            <img src="images/11.png" alt='' />
                        </div>
                        <div class="content">
                        </div>
                        <div>
                            <h3 className='nome'>Presente</h3>
                            <div class="price"><span>R$  </span>40,00</div>
                            <div class="icon">
                                <a href="presente" class="fas fa-shopping-cart"><span></span></a>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="img">
                            <img src="images/12.png" alt='' />
                        </div>
                        <div class="content">
                        </div>
                        <div>
                            <h3 className='nome'>Vazinho</h3>
                            <div class="price"><span>R$  </span>40,00</div>
                            <div class="icon">
                                <a href="vazinho" class="fas fa-shopping-cart"><span></span></a>
                            </div>
                        </div>
                    </div>

                    <div class="card">
                        <div class="img">
                            <img src="images/13.png" alt='' />
                        </div>
                        <div class="content">
                        </div>
                        <div>
                            <h3 className='nome'>Bolsa Fashion</h3>
                            <div class="price"><span>R$  </span>40,00</div>
                            <div class="icon">
                                <a href="bolsa" class="fas fa-shopping-cart"><span></span></a>
                            </div>
                        </div>
                    </div>


                    <div class="card">
                        <div class="img">
                            <img src="images/14.png" alt='' />
                        </div>
                        <div class="content">
                        </div>
                        <div>
                            <h3 className='nome'>Bolsa Lírio</h3>
                            <div class="price"><span>R$  </span>40,00</div>
                            <div class="icon">
                                <a href="bolsa" class="fas fa-shopping-cart"><span></span></a>
                            </div>
                        </div>
                    </div>



                    <div class="card">
                        <div class="img">
                            <img src="images/15.png" alt='' />
                        </div>
                        <div class="content">
                        </div>
                        <div>
                            <h3 className='nome'>Bolsa green</h3>
                            <div class="price"><span>R$  </span>40,00</div>
                            <div class="icon">
                                <a href="bolsa" class="fas fa-shopping-cart"><span></span></a>
                            </div>
                        </div>
                    </div>


                    {/* <!--Card --> */}
                    <div id='galeria'>
                        <div className='foto' id='foto1'>
                    <div class="card">
                        <div >
                            <a href='#foto1'>
                            <img src="images/16.png" alt='' />
                            </a>
                            <div className='detalhes'>
                                Chaveiro borboletas feito com carinho para presentear quem vc gosta!<br/><a href='#fechar'>X</a>
                            </div>
                            
                        </div>
                        <div class="content">
                        </div>
                        {/* <div>
                            <h3 className='nome'>Chaveiro Borboletas</h3>
                            <div class="price"><span>R$  </span>40,00</div>
                            <div class="icon">
                                <div className='nav-item'>
                                    <Link
                                        to='/carrinho'
                                        className="icon"
                                    >
                                        <div class="icon">
                                            <a href="#" class="fas fa-shopping-cart"></a>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                        </div> */}
                    </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Cards;
